import {Models} from "@rematch/core"
import {qrCodeLogin} from "./qrCodeLogin"
import {session} from "./session"
import {userModule} from "./userModule"
import {test} from "./test"
import {file} from "./file"
import {company} from "./company"
import {examiner} from "./examiner"
import {school} from "./school"
import {schoolTouch} from "./schoolTouch"
import {city} from "./city"
import {uploadCert} from "./uploadCert"
import {examPlan} from "./examPlan"
import {order} from "./order"
import {pay} from "./pay"
import {itemType} from "./itemType"
import {serviceOrders} from "./serviceOrders"
import {showOrders} from "./showOrders"
import {activitySign} from "./activitySign"
import {activity} from "./activity"

export interface RootModel extends Models<RootModel> {
  activity: typeof activity
  activitySign: typeof activitySign
  city: typeof city
  company: typeof company
  examiner: typeof examiner
  examPlan: typeof examPlan
  file: typeof file
  itemType: typeof itemType
  order: typeof order
  pay: typeof pay
  qrCodeLogin: typeof qrCodeLogin
  school: typeof school
  schoolTouch: typeof schoolTouch
  serviceOrders: typeof serviceOrders
  showOrders: typeof showOrders
  session: typeof session
  test: typeof test
  uploadCert: typeof uploadCert
  userModule: typeof userModule
}

export const models: RootModel = {
  activity,
  activitySign,
  city,
  company,
  examiner,
  examPlan,
  file,
  itemType,
  order,
  pay,
  qrCodeLogin,
  school,
  schoolTouch,
  serviceOrders,
  showOrders,
  session,
  test,
  uploadCert,
  userModule,
}
